const storeDictPT = {
  store: "Loja",
  storeSettings: "Configurações",
  storeOrders: "Pedidos",
  storeSchedules: "Agendamentos",
  storeSchedulesSubtitle: "Gerencie os agendamentos sincronizados com o Google Calendar",
  storeTotalOrders: "Total de pedidos",
  storePendingOrders: "Pedidos pendentes",
  orderDetails: "Detalhes do pedido",
  storeOrderDetails: "Detalhes do pedido",
  storeProducts: "Produtos",
  myStore: "Minha Loja",
  storePanelTitle: "Painel da loja",
  storePanelSubtitle: "Gerencie as operações da sua loja.",
  storeOperations: "Operações",
  storeRegisteredArticles: "Artigos registrados",
  storeRevenue: "Vendas",
  storePendingOperations: "Operações pendentes",
  sinceStart: "Desde o início",
  awaitingProcessing: "Aguardando processamento",
  latestOrders: "Últimos pedidos",
  allOrders: "Todos os pedidos",
  newProduct: "Novo produto",
  settingsTabGeneral: "Geral",
  settingsTabLocationContact: "Localização e contatos",
  settingsTabIntegrations: "Integrações",
  integrationsDisabled: "Desativado",
  backToPage: "Voltar à página",
  newProductOverlayTitle: "Novo produto",
  stepGeneralInfo: "Informações gerais",
  stepGeneralInfoSubtitle: "Aumente as vendas com informações detalhadas sobre o produto",
  stepPriceDetails: "Detalhes de preço",
  stepPriceDetailsTitle: "Adicione detalhes do produto",
  stepPriceDetailsSubtitle: "Aumente as vendas com informações detalhadas sobre o produto",
  stepProductImage: "Imagem do produto",
  stepStockAvailability: "Estoque e disponibilidade",
  stepSummary: "Resumo",
  next: "Próximo",
  previous: "Anterior",
  submitProduct: "Cadastrar produto",
  cancel: "Cancelar",
  filterByOrderId: "ID do pedido",
  filterByDateRange: "Intervalo de datas",
  filterByStatus: "Status",
  search: "Pesquisar",
  customer: "Cliente",
  product: "Produto",
  service: "Serviço",
  downloadable: "Baixável",
  integrationsComingSoon: "Em breve",
  website: "Website",
  save: "Guardar",
  logo: "Logo",
  storeSettingsLogoHelp: "Imagem exibida como logo da sua loja. Recomendado: proporção 4:1.",
  storeSettingsTitleHelp: "Nome exibido da sua loja.",
  storeSettingsDescriptionHelp: "Breve descrição da sua loja.",
  storeSettingsWebsiteHelp: "URL do site da sua loja ou empresa.",
  storeSettingsSocialHelp:
    "Apenas o nome de utilizador ou perfil (ex.: minhapagina para instagram.com/minhapagina).",
  storeSettingsMinOrderHelp: "Valor mínimo do pedido para aplicar a regra de frete selecionada.",
  storeSettingsFreightValueHelp:
    "Valor ou percentual de desconto aplicado quando a regra for cumprida.",
  storeSettingsClickToUpload: "Clique para carregar",
  storeSettingsOrDragDrop: "ou arraste e solte",
  storeSettingsLogoFormats: "PNG, JPG ou WebP. Máx. 5 MB.",
  storeSettingsCategoriesHelp: "Categorias às quais a sua loja pertence.",
  storeSettingsAtecoHelp: "Pesquise e adicione códigos ATECO da atividade da sua loja.",
  storeSettingsStoreLinkHelp: "Só letras minúsculas e números, até 20 caracteres. Deixe em branco para não usar link personalizado.",
  storeSettingsStoreLinkPlaceholder: "minhaloja",
  storeSettingsCopyLink: "Copiar link",
  storeSettingsLinkCopied: "Link copiado!",
  storeSettingsCopyLinkDisabled: "Salve o link personalizado para poder copiá-lo.",
  free: "Grátis",
  productInfo: "Informações do produto",
  editProduct: "Editar produto",
  storeEditTabGeneral: "Detalhes gerais",
  storeEditTabImages: "Imagens do produto",
  storeEditTabStock: "Situação do estoque",
  storeEditImagesHint: "Utilize a aba Detalhes gerais para gerir as imagens do produto.",
  storeEditStockHint: "Utilize a aba Detalhes gerais para gerir o estoque e a publicação.",
  noProducts: "Nenhum produto registado.",
  errorLoadingProduct: "Erro ao carregar o produto.",
  orderDetailsSubtitle: "Pode monitorar e gerir os detalhes do pedido.",
  orderDetailsStep1Send: "Enviar pedido",
  orderDetailsStep2Delivered: "Pedido entregue",
  orderDetailsStep3Payment: "Receber pagamento",
  orderDetailsStep4Completed: "Compra concluída",
  orderDetailsAlertToProcess:
    "A processar. Recebeu um novo pedido! Verifique a disponibilidade dos produtos e inicie a preparação.",
  orderDetailsTransactionId: "ID da transação",
  orderDetailsSummaryPurchase: "Resumo da compra",
  orderDetailsSubtotal: "Subtotal",
  orderDetailsCoupon: "Cupom",
  orderDetailsVat: "IVA",
  orderDetailsShippingCosts: "Despesas de envio",
  orderDetailsTotal: "Total",
  orderDetailsTotalReceived: "Total recebido",
  orderDetailsCashback: "Cashback",
  orderDetailsPaymentMethod: "Método de pagamento",
  orderDetailsCreditCard: "Cartão de crédito",
  orderDetailsExtracredit: "Extracredit",
  orderDetailsBuyer: "Comprador",
  orderDetailsContact: "Contato",
  orderDetailsPhone: "Telefone",
  orderDetailsEmail: "E-mail",
  orderDetailsShippingData: "Dados de envio",
  orderDetailsStatusToProcess: "A processar",
  orderDetailsStatusShipped: "Enviado",
  orderDetailsStatusDelivered: "Entregue",
  orderDetailsCancelOrder: "Cancelar pedido",
  orderDetailsSendProduct: "Enviar produto",
  orderDetailsOrderConfirmed: "Pedido confirmado",
  orderDetailsPaymentApproved: "O pagamento foi aprovado.",
  orderDetailsProductInTransit: "O produto está em trânsito.",
  orderDetailsProductDelivered: "O produto foi entregue.",
  orderDetailsLoading: "A carregar...",
  shippingIncluded: "Envio incluído",
  notifyAllUsers: "Notificar todos os utilizadores",
  notifyMyEconomicCircle: "Notificar o meu círculo económico",
  notifications: "Notificações",
  fileForDownload: "Arquivo para download",
  sampleFileOptional: "Amostra / pré-visualização (opcional)",
  downloadFileType: "Tipo de arquivo",
  downloadTypeAudio: "Áudio",
  downloadTypeVideo: "Vídeo",
  downloadTypeImage: "Imagem",
  downloadTypeDocument: "Documento",
  publishProductNow: "Publicar produto já",
  uploadZoneInstruction: "Escolha um arquivo ou arraste-o aqui.",
  uploadZoneFormatsImages: "Formatos JPEG, PNG e MP4, até 50 MB.",
  uploadZoneFormatsFile: "Todos os formatos, até 100 MB.",
  browseFiles: "Procurar arquivo",
  primaryImage: "Principal",
  activate: "Ativar",
  confirmCode: "Confirmar código",
  whatsappDisconnected: "WhatsApp desconectado",
  whatsappHasBeenDisconnected: "WhatsApp foi desconectado com sucesso.",
  errorDisconnectingWhatsApp: "Erro ao desconectar o WhatsApp. Por favor, tente novamente.",
  activated: "Ativado",
  deactivated: "Desativado",
  removeIntegration: "Remover integração",
  confirmRemoveIntegration:
    "Tem certeza de que deseja remover esta integração? Esta ação não pode ser desfeita.",
  confirmation: "Confirmação",
  yes: "Sim",
  no: "Não",
  googleCalendar: "Google Calendar",
  googleCalendarDescription: "Sincronize seus eventos e compromissos com o Google Calendar",
  apiKey: "Chave da API",
  clientId: "ID do Cliente",
  clientSecret: "Segredo do Cliente",
  configure: "Configurar",
  integrationsDescription:
    "Conecte sua loja com ferramentas externas para otimizar seu fluxo de trabalho",
  whatsappIntegrationDescription:
    "Conecte sua loja ao WhatsApp para atendimento direto aos clientes",
  phoneNumber: "Número de telefone",
  phoneNumber1: "Número de telefone",
  enterYourPhoneNumber: "Digite seu número de telefone",
  attention: "Atenção",
  pleaseProvidePhoneNumber: "Por favor, forneça um número de telefone",
  codeSent: "Código enviado",
  confirmationCodeSentToWhatsApp: "Código de confirmação enviado para o WhatsApp",
  error: "Erro",
  errorConnectingToServer: "Erro ao conectar ao servidor",
  pleaseProvideConfirmationCode: "Por favor, forneça o código de confirmação",
  success: "Sucesso",
  whatsappConfiguredSuccessfully: "WhatsApp configurado com sucesso",
  invalidConfirmationCode: "Código de confirmação inválido",
  configurationSavedSuccessfully: "Configuração salva com sucesso",
  goBackAndResendCode: "Voltar e reenviar código",
  confirmationCode: "Código de confirmação",
  enterReceivedCode: "Digite o código recebido",
  integrationData: "Dados da integração",
  redirectedToGoogleAuth:
    "Redirecionado para autenticação do Google. Complete o processo na nova aba.",
  errorGettingAuthUrl: "Erro ao obter URL de autenticação",
  googleCalendarDisconnected: "Google Calendar desconectado",
  googleCalendarHasBeenDisconnected: "Google Calendar foi desconectado com sucesso.",
  errorDisconnectingGoogleCalendar:
    "Erro ao desconectar o Google Calendar. Por favor, tente novamente.",
  noSchedulesYet: "Nenhum agendamento ainda",
  scheduleConnectGoogleCalendar:
    "Conecte o Google Calendar na aba de integrações para sincronizar seus agendamentos",
  confirmed: "Confirmado",
  pending: "Pendente",
  manageOrders: "Gerencie seus pedidos",
  manageProducts: "Gerencie seus produtos",
  manageSchedules: "Gerencie seus agendamentos",
  viewSchedules: "Ver agendamentos",
  scheduleSetupTitle: "Configuração inicial necessária",
  scheduleSetupDescription: "Para usar o sistema de agendamentos, siga os passos abaixo:",
  scheduleStep1Title: "Conectar Google Calendar",
  scheduleStep1Description: "Conecte sua conta do Google Calendar para sincronizar agendamentos",
  scheduleStep1Connected: "Google Calendar conectado com sucesso",
  scheduleStep2Title: "Configurar preferências de horário",
  scheduleStep2Description:
    "Defina os dias e horários em que os clientes podem reservar seus serviços.",
  scheduleStep2Configured: "Preferências de horário configuradas",
  connect: "Conectar",
  integrationComplete: "Integração concluída!",
  yourAccountIsNowConnected: "A sua conta agora está conectada.",
  whatsappBotReady: "O bot do WhatsApp está pronto para ler sua agenda.",
  integrationIncomplete: "Integração incompleta",
  youNeedToCompleteTheFollowingSteps: "Você precisa completar os seguintes passos.",
  standardAppointmentLength: "Duração padrão do agendamento",
  scheduleBufferLabel: "Buffer entre atendimentos (min)",
  scheduleBufferHelp: "Descanso entre atendimentos",
  scheduleAppointmentLengthHelp: "Duração padrão do atendimento",
  scheduleWorkStartLabel: "Início do expediente",
  scheduleWorkEndLabel: "Fim do expediente",
  scheduleSelectDays: "Selecione os dias de atendimento",
  scheduleClientInstructionsLabel: "Instruções para o cliente",
  scheduleClientInstructionsPlaceholder: "Ex.: chegue no local com 15 minutos de antecedência.",
  scheduleClientInstructionsHelp:
    "Essas instruções serão enviadas ao cliente ao confirmar o agendamento.",
  monday: "Segunda",
  tuesday: "Terça",
  wednesday: "Quarta",
  thursday: "Quinta",
  friday: "Sexta",
  saturday: "Sábado",
  sunday: "Domingo",
  openYourGoogleCalendar: "Abrir seu Google Calendar",
  availability: "Disponibilidade",
  scheduleStep3Title: "Agendamento e reservas",
  scheduleStep3Description:
    "Gerencie seus compromissos e solicitações de suporte diretamente da sua agenda.",
  configureYourAvailability: "Configure sua disponibilidade",
  defineDaysAndTimes: "Defina os dias e horários em que os clientes podem reservar seus serviços.",
  removeWhatsAppIntegration: "Remover a integração com o WhatsApp?",
  removeWhatsAppIntegrationDescription:
    "O número de telefone será excluído dos nossos sistemas e o botão de contato não ficará mais visível para os clientes da sua loja. Você pode reativar o serviço a qualquer momento.",
  removeGoogleCalendarIntegration: "Remover a integração com o Google Calendar?",
  removeGoogleCalendarIntegrationDescription:
    "A conexão com o Google Calendar será removida e seus agendamentos não serão mais sincronizados. Você pode reativar o serviço a qualquer momento.",
  remove: "Remover",
  physicalStore: "Loja Física",
  physicalStoreConventionTitle: "Convenção de Loja Física",
  physicalStoreConventionSubtitle: "Leia e assine a convenção para ativar sua loja física e começar a receber pagamentos.",
  physicalStoreConventionAlreadySigned: "Convenção já assinada",
  physicalStoreConventionAlreadySignedDesc: "Você já assinou a convenção de loja física. Não é necessária nenhuma ação adicional.",
  physicalStoreConventionAccept: "Li e aceito os termos da convenção",
  physicalStoreConventionConfirm: "Confirmar e assinar",
  physicalStoreConventionSignedSuccess: "Convenção assinada com sucesso!",
  physicalStoreConventionSignedError: "Erro ao assinar a convenção. Tente novamente.",
  physicalStoreConventionLoading: "Carregando convenção...",
  physicalStoreConventionCommercialName: "Nome comercial",
  physicalStoreConventionCompanyName: "Nome da empresa",
  physicalStoreConventionAddress: "Endereço",
  physicalStoreConventionNumber: "Número",
  physicalStoreConventionCity: "Cidade",
  physicalStoreConventionPostalCode: "CEP / Código postal",
  physicalStoreConventionProvince: "Província / Estado",
  physicalStoreConventionPhone: "Telefone",
  physicalStoreConventionProofPhoto: "Foto do estabelecimento",
  physicalStoreConventionProofPhotoPlaceholder: "Clique para selecionar uma imagem",
  physicalStoreConventionUploading: "Enviando...",
  physicalStoreConventionPendingTitle: "Comprovante em análise",
  physicalStoreConventionPendingMessage: "Seu comprovante foi enviado e está aguardando análise. Em breve você poderá utilizar a loja física.",
  physicalStoreConventionRejectedTitle: "Comprovante rejeitado",
  physicalStoreConventionApprovedTitle: "Loja física aprovada",
  physicalStoreConventionApprovedMessage: "Sua loja física foi aprovada. Você já pode utilizar todos os recursos de pagamento físico.",
  physicalStoreConventionLegalRepresentative: "Nome do representante legal",
  physicalStoreConventionTaxId: "CPF/CNPJ",
  physicalStoreConventionMerchantCategory: "Categoria do estabelecimento",
  physicalStoreConventionViewDoc: "Ver termos da convenção",
  physicalStoreNewPayment: "Novo pagamento",
  physicalStoreNewPaymentDesc: "Crie uma nova cobrança com QR Code",
  physicalStorePaymentsList: "Histórico de pagamentos",
  physicalStorePaymentsListDesc: "Veja todos os pagamentos recebidos",
  physicalStoreCameraPayment: "Pagar com câmera",
  physicalStoreCameraPaymentDesc: "Escaneie o QR Code para receber",
  physicalStoreVerificationTitle: "Verificação da loja física",
  physicalStoreVerificationSubtitle: "Envie um comprovante para habilitar cobranças",
  physicalStoreVerificationPendingSubtitle: "Seu comprovante está em análise",
  physicalStoreVerificationPendingMessage:
    "Seu comprovante foi enviado e está aguardando análise. Em breve você poderá criar cobranças.",
  physicalStoreVerificationRejected: "Comprovante rejeitado",
  physicalStoreVerificationAddressPlaceholder: "Rua / Av.",
  physicalStoreVerificationNumberPlaceholder: "Nº",
  physicalStoreVerificationPostalCodePlaceholder: "00000-000",
  physicalStoreVerificationStatePlaceholder: "UF",
  addProduct: "Adicionar produto",
  searchProductByName: "Buscar pelo nome do produto",
  productsViewGrid: "Visualização em grade",
  productsViewList: "Visualização em lista",
  productListValue: "Valor",
  productListRegistration: "Cadastro",
  sortBy: "Ordenar",
  sortMostRecent: "Mais recente",
  sortOldest: "Mais antigo",
  sortHighestValue: "Maior valor",
  unpublishProduct: "Despublicar produto",
  publishProduct: "Publicar produto",
  notifyUsers: "Notificar utilizadores",
  notifyEconomicCircle: "Notificar círculo econômico",
  productTypeModalTitle: "Que tipo de produto ou serviço você vai cadastrar?",
  productTypePhysical: "Produto físico",
  productTypePhysicalDesc: "Produtos que serão entregues aos clientes.",
  productTypeService: "Serviço",
  productTypeServiceDesc: "Serviço prestado por você, aos clientes.",
  productTypeDigital: "Produto digital",
  productTypeDigitalDesc: "Os clientes poderão fazer download do seu produto.",
  addProductDetails: "Adicionar detalhes do produto",
  addProductDetailsSubtitle: "Descreva os detalhes do seu produto para visualização.",
  addServiceDetails: "Adicionar detalhes do serviço",
  addServiceDetailsSubtitle: "Descreva os detalhes do seu serviço para visualização.",
  productName: "Nome do produto",
  productNamePlaceholder: "Digite o nome do produto",
  serviceNamePlaceholder: "Digite o nome do serviço",
  productState: "Estado do produto",
  productStateNew: "Novo",
  productStateUsed: "Usado",
  withVariation: "Com variação?",
  withVariationHelp: "Ideal para itens com diferentes tamanhos, cores.",
  forSale: "À venda",
  forSaleHelp: "Publique para visualização imediata.",
  fullDescription: "Descrição completa",
  fullDescriptionPlaceholder: "Cadastre uma descrição completa do seu produto.",
  fullDescriptionPlaceholderService: "Cadastre uma descrição completa do seu serviço.",
  fullDescriptionTip: "Capriche na descrição detalhada",
  stock: "Estoque",
  stockPlaceholder: "Ex.: 10",
  category: "Categoria",
  subcategory: "Subcategoria",
  selectCategory: "Selecione uma categoria",
  selectSubcategory: "Selecione uma subcategoria",
  selectFileType: "Selecione um tipo de arquivo",
  requiredFieldsHint: "* campos obrigatórios para publicar",
  productCharacteristics: "Características do produto",
  productCharacteristicsSubtitle:
    "Organize informações em grupos. Em cada grupo, adicione um título e os pares de informação que aparecerão na aba de características do produto.",
  serviceCharacteristics: "Características do serviço",
  serviceCharacteristicsSubtitle:
    "Organize as informações em grupos. Em cada grupo, adicione um título e os pares de informação que aparecerão na aba de características de serviço.",
  noCharacteristics: "Nenhuma característica cadastrada.",
  createCharacteristics: "Criar características para meu produto",
  createCharacteristicsService: "Criar características para meu serviço",
  characteristicsFooter: "Esse conteúdo irá aparecer na aba de Características do produto.",
  characteristicsFooterService: "Esse conteúdo irá aparecer na aba de Características do serviço.",
  addGroup: "Adicionar grupo",
  addItem: "Adicionar item",
  characteristicTitle: "Título",
  characteristicDescription: "Descrição",
  groupNamePlaceholder: "Digite o nome do grupo",
  characteristicTitlePlaceholder: "Ex: Material",
  characteristicDescriptionPlaceholder: "Ex: Algodão premium",
  saveCharacteristicGroup: "Salvar",
  removeCharacteristicGroup: "Remover grupo",
  characteristicGroupItem: "{count} item",
  characteristicGroupItems: "{count} itens",
  unnamedCharacteristicGroup: "Características",
  priceDetails: "Defina detalhes de preço",
  priceDetailsSubtitle: "Quanto o produto irá custar, quais descontos e cashback que serão aplicados.",
  priceDetailsSubtitleService:
    "Quanto seu serviço irá custar, quais descontos e cashback que serão aplicados.",
  discountAndShippingDetails: "Defina detalhes de descontos e frete",
  discountAndShippingSubtitle:
    "Tipo de frete, medidas do produto, quais descontos e cashback que serão aplicados.",
  priceHelp: "Defina quanto quer receber pelo produto.",
  priceHelpService: "Defina quanto quer receber pelo serviço.",
  discountOptional: "Desconto (Opcional)",
  discountHelp: "Mostre que seu produto está com desconto.",
  discountHelpService: "Mostre que seu serviço está com desconto.",
  cashbackPercent: "Percentual de Cashback",
  cashbackHelpPrefix: "Para entender como o preço final é calculado, acesse a nossa",
  promoterCommissionPercent: "Comissão para Promoter (opcional)",
  promoterCommissionHelp: "Promoters que divulgarem este produto pelo link deles recebem essa % do valor do item em cada venda. O valor é descontado do seu repasse. Deixe 0 para não oferecer comissão.",
  promoterCommissionInvalid: "A comissão para Promoter deve ficar entre 0% e 100%.",
  priceCalculator: "calculadora de preços",
  productDimensions: "Informe as dimensões do seu produto",
  productDimensionsSubtitle: "As medidas são usadas para calcular o frete.",
  heightCm: "Altura (cm)",
  widthCm: "Largura (cm)",
  lengthCm: "Comprimento (cm)",
  weightKg: "Peso (kg)",
  shipping: "Frete",
  shippingHelp: "Como você prefere que o frete seja tratado para seu produto.",
  shippingSimulator: "Simulador de frete",
  breadcrumbsAriaLabel: "Navegação",
  freeShipping: "Frete grátis",
  freeShippingDesc: "A loja é responsável pelos custos de frete.",
  paidShipping: "Frete pago",
  paidShippingDesc: "O cliente paga o frete no checkout da compra.",
  localPickup: "Coleta no local",
  localPickupDesc: "O cliente poderá retirar o pedido direto na loja.",
  productVariations: "Variações de produto",
  productVariationsSubtitle:
    "Você poderá escolher até 2 atributos e até 5 variações para cada produto cadastrado.",
  addVariationOptions: "Adicione opções como cor ou tamanho.",
  addAnotherOption: "Adicionar outra opção",
  optionName: "Nome da opção",
  optionValues: "Valores da opção",
  addValue: "Adicionar valor",
  done: "Concluído",
  variant: "Variante",
  variantPrice: "Preço",
  variantStock: "Estoque",
  selectImage: "Selecionar imagem",
  uploadedImages: "Imagens carregadas",
  addFiles: "Adicionar arquivos",
  confirm: "Confirmar",
  addProductImages: "Adicionar as imagens do produto",
  addProductImagesSubtitle:
    "Use fotos com ângulos diferentes para oferecer uma melhor experiência ao seu cliente.",
  addServiceImages: "Adicionar as imagens do serviço",
  addServiceImagesSubtitle:
    "Use fotos com ângulos diferentes para oferecer uma melhor experiência ao seu cliente.",
  uploadFiles: "Carregar arquivos",
  uploadZoneFormatsProductImages: "Formatos JPEG, PNG e WEBP. Até 5 MB.",
  digitalProductFiles: "Arquivos do seu produto digital",
  digitalProductFilesSubtitle: "Envie a capa, o arquivo principal e uma amostra opcional.",
  coverImage: "Imagem de capa",
  coverImageHelp: "Imagem que aparece na loja.",
  coverImageFormats: "Formatos aceitos: JPG, PNG e WebP.",
  coverImageSize: "Tamanho máximo: 3MB.",
  mainProductFile: "Arquivo principal do produto",
  mainProductFileHelp: "Arquivo que o cliente recebe após a compra.",
  mainProductFileFormats: "Formatos aceitos: Todos os formatos.",
  mainProductFileSize: "Tamanho máximo: 100MB.",
  previewSample: "Amostra prévia (opcional)",
  previewSampleHelp: "Versão de demonstração ou reduzida do produto.",
  previewSampleFormats: "Formatos aceitos: Todos os formatos.",
  previewSampleSize: "Tamanho máximo: 100MB.",
  selectFiles: "Selecionar arquivos",
  replaceFile: "Trocar arquivo",
  viewFile: "Visualizar",
  uploadedSuccessfully: "Enviado com sucesso",
  requiredFilesToPublish: "Os arquivos obrigatórios precisam ser enviados para publicar o produto.",
  dragDropOrSelect: "Arraste e solte aqui",
  uploadZoneHelp: "ou selecione um arquivo do seu computador.",
  register: "Cadastrar",
  noProductsFound: "Nenhum produto encontrado.",
  notifyConfirmUsers: "Deseja notificar todos os utilizadores sobre este produto?",
  notifyConfirmCircle: "Deseja notificar o seu círculo econômico sobre este produto?",
  notifyInsufficientBalance: "Saldo de ExtraBonus insuficiente para enviar a notificação.",
  productPublished: "Produto publicado com sucesso.",
  productUnpublished: "Produto despublicado com sucesso.",
  productNotified: "Notificação enviada com sucesso.",
  examplePlaceholder: "Ex.:",
};

export default storeDictPT;
